import { z } from 'zod';

export const labelGroupFormSchema = z.object({
  name: z.string().trim().min(1).max(200),
  labels: z.array(z.object({ label: z.string(), value: z.string() })).min(1),
  users: z.array(z.object({ label: z.string(), value: z.string() })).optional(),
  notes: z.string().max(500).optional(),
});

export type LabelGroupFormSchema = z.infer<typeof labelGroupFormSchema>;
